<template>
  <div class="grid-container">
    <div class="grid-x grid-margin-x grid-padding-x mt-50">
        <div class="cell small-12 mt-50 mb-50">
          <div class="text-center">
            <h1 class="big-title">Thores Change Your Life Challenge</h1>
            <h4><b>Partnerbedingungen der ERGOBeratung und Vertrieb AG (EBV)</b></h4>
          </div>
          <div class="text mt-40 mb-50">
            Als registrierter Vermittler, im weiteren „Partner“ genannt, können Sie den Besuchern ihrer Homepage und Kunden mit dem Webservice
            „Thores Change Your Life-Challenge“ helfen, die Risiken des Arbeitskraftverlustes zu erkennen und sich dagegen abzusichern. Die EBV ist
            exklusive Lizenznehmerin der Software, über die der Webserice zur Verfügung gestellt wird.
            <br><br>
            Mit der Nutzung unseres Webservice akzeptieren Sie die nachfolgenden Partnerbedingungen und die Datenschutzerklärung :
            <br><br>
            <b>1. Unsere gemeinsamen Ziele.</b>
            Mit dem Webservice möchten wir möglichst viele Menschen für die Risiken und Auslöser sensibilisieren, die zum Verlust ihrer Arbeitskraft
            und ihres Einkommens führen können. Anschließend möchten wir dazu motivieren, für den Fall der Fälle vorzusorgen. Dazu empfehlen
            wir Besuchern, ihre Lebensumstände anzupassen und sich fachkundig beraten zu lassen. Im Anschluss daran können die User Kontakt
            mit dem auf die Vorsorgeberatung spezialisierten Versicherungsvermittler, welcher sich über die Landingpage für die Nutzung des
            Webservice registriert hat, aufnehmen und sich für eine geeignete Vorsorge beraten lassen.
            <br><br>
            <b>2. Partner erhalten personalisierte Versionen mit ihren eigenen Kontaktdaten</b>
            Als „Partner“ können Sie die Software, über die der Webservice zur Verfügung gestellt wird, kostenlos nutzen, um die Besucher der
            Homepage, auf der der Webservice eingebunden wird, für das Risiko des Arbeitskraftverlustes zu sensibilisieren und zwecks
            Vorsorgeberatung in Kontakt mit sich zu bringen. Dazu müssen Sie sich einfach eine personalisierte Version der Software erstellen,
            indem Sie die Bedingungen akzeptieren, Ihre Kontaktdaten eintragen und diese an uns senden. Anschließend erhalten von uns einen
            individuellen Link und können diesen einfach an Ihre Kontakte senden, bzw. in Ihre eigene Webseite einbinden. Ihre Kontaktdaten
            werden in den Webservice eingetragen und ermöglichen es, dass Kontakt-/Beratungsanfragen der Besucher direkt an Sie zugestellt
            werden. Die Erstellung personalisierter Versionen unseres Webservice ist kostenfrei. Bitte beachten Sie jedoch im Weiteren unsere
            Ausschlüsse.
            <br><br>
            <b>3. Partner beraten User</b>
            Als Partner erklären Sie sich bereit, mit den Usern, die Kontakt mit Ihnen aufnehmen, individuelle Beratungen durchzuführen. Diese
            Vorsorgeberatungstermine können persönlich, telefonisch oder auch online durchgeführt werden. Die Termine haben für den User
            kostenfrei zu erfolgen. Zwecks Terminvereinbarung nehmen Sie schnellstmöglich selbst Kontakt mit den Usern auf.
            <br><br>
            <b>4. Partner dürfen den Webservice nicht kopieren oder verändern</b>
            Die Funktionsweise unseres Webservice, dessen Programmcode, Gestaltung und Inhalte sind urheberrechtlich geschützt und dürfen
            weder kopiert, nachgeahmt, verändert noch zweckwidrig eingesetzt werden. Alle übrigen Rechte bleiben vorbehalten.
            <br><br>
            <b>5. Verfügbarkeit unserer Services.</b>
            Wir behalten uns vor, die Nutzung unseres Webservice jederzeit insgesamt oder in Bezug auf einzelne Bestandteile daraus ohne Angabe
            von Gründen für alle oder einzelne Nutzer einzuschränken, zu unterbrechen oder einzustellen. Aus der Nutzung entsteht kein Anspruch
            auf eine inhaltliche oder zeitlich unbefristete Verfügbarkeit unseres Webservice. Hiervon ausgenommen sind individuelle Webseiten bzw.
            App-Versionen, die wir für Kunden mit einem kostenpflichtigen Servicevertrag hosten.
            <br><br>
            <b>6. Ausschlüsse und Verbote.</b>
            Eine automatisierte Nutzung unseres Webservice ist ausgeschlossen. Es ist verboten, unseren Webservice ohne unsere Erlaubnis
            kostenpflichtig Dritten anzubieten, zu vermieten, zu verpachten bzw. im Rahmen anderer kostenpflichtiger Angebote weiterzugeben.
            Es ist verboten, unseren Webservice auf Webseiten einzubinden, die pornografischen, diskriminierenden oder sonstigen in irgendeiner
            Weise anstößigen Charakter haben bzw. zu Hass und Gewalt aufrufen. Ausgeschlossen ist die Nutzung unserer Services auf Webseiten mit:
            <br><br>
            a) eindeutig sexuellen Inhalten;
            <br><br>
            b) eindeutig gewaltbezogenen oder Gewalt verherrlichenden Inhalten;
            <br><br>
            c) verleumderischen oder diffamierenden Inhalten;
            <br><br>
            d) diskriminierenden Inhalten oder Inhalten mit diskriminierenden Praktiken in Bezug auf Rasse, Geschlecht, Religionszugehörigkeit,
            Staatsangehörigkeit, Behinderung, sexuelle Orientierung oder Lebensalter;
            <br><br>
            e) der Aufforderung zur oder Durchführung von illegalen Aktivitäten;
            <br><br>
            f) ein Verstoß gegen geistige Eigentumsrechte in sonstiger Art und Weise.
            <br><br>
            Bei Verstößen oder auch im Zweifelsfall steht es uns frei, die Nutzung unseres Webservice ohne Angabe von Gründen zu untersagen.
            <br><br>
            <b>7. Schutz der Daten der Partner</b>
            Um Ihnen als Partner unseren Webservice anbieten zu können, ist es notwendig, persönliche Daten von Ihnen abzufragen und zu erfassen.
            Diese Daten unterliegen strengen Datenschutzbestimmungen und werden an Dritte nur unter Einhaltung der Partnerbedingungen und der
            Datenschutzerklärung weitergegeben, der Sie mit Registrierung zur Nutzung des Webservice zustimmen.
            <br><br>
            <b>8. Schutz der Userdaten</b>
            Die von den Usern des Webservice eingegebenen (Kontakt-)Daten unterliegen dem Datenschutz und sind streng vertraulich. Sie dürfen
            grundsätzlich nur an von uns autorisierte Dienstleister und Partner weitergegeben werden, die uns dabei unterstützen, unseren
            Webservices vereinbarungsgemäß zu erbringen. Dies erfolgt unter Einhaltung der Nutzungsbedingungen und der Datenschutzerklärung,
            denen der User zustimmen muss, um den Webservice nutzen zu können. In unserer Datenschutzerklärung für die User ist klar geregelt,
            dass die Daten unserer User nur zu dem darin vereinbarten Zweck verwendet werden dürfen. Eine darüber hinaus gehende Nutzung der
            Daten bzw. eine Weitergabe an unbefugte Dritte ist nicht möglich.
            <br><br>
            <b>9. Haftungsausschluss.</b>
            Wir sind bestrebt, mit unseren Webservice korrekte Informationen zu liefern. Für die Richtigkeit, Vollständigkeit und Aktualität der Angaben,
            der Rechenergebnisse sowie für die Verfügbarkeit der Services wird jedoch keine Haftung übernommen. Wir haften ferner nicht für die
            Inhalte externer Anbieter, welche unseren Webservice auf ihrer Seite einbinden bzw. die über Links von unseren Webseiten heraus erreicht
            werden können. Auch sind sämtliche Schadensersatzansprüche aus der Nutzung bzw. Nichtnutzung, insbesondere im Zusammenhang mit
            Entscheidungen und Handlungen, die aufgrund unserer Webservice vorgenommen wurden, ausgeschlossen. Für Schadensersatzansprüche
            aus der Verletzung von Leben und Gesundheit, die auf einer Pflichtverletzung der EBV beruht, haftet die EBV jedoch für Vorsatz und grobe
            Fahrlässigkeit. Die Haftung nach dem Produkthaftungsgesetz bleibt unberührt.
            <br><br>
            <b>10. Gerichtstand.</b>
            Als Gerichtsstand für sämtliche Streitigkeiten, die in Zusammenhang mit diesen Partnerbedingungen stehen, wird Düsseldorf, Deutschland
            vereinbart.
            <br><br>
            <b>Sonstiges.</b>
            Diese Partnerbedingungen gelten auch für alle Updates und Programmergänzungen. Sollten einzelne Bestimmungen dieser
            Partnerbedingungen unwirksam sein, bleibt die Wirksamkeit der anderen Bestimmungen unberührt.
          </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'partnerPolicy',
  components: {
    
  },
  data() {
    return {
      state: this.$store.state,
      ui: {

      }
    }
  },
  async mounted() {
    this.$sleep(300)
    window.scrollTo(0,0)
    this.$store.trackingView("Partnerbedingungen");
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="stylus" scoped>
.big-title {
  font-family: 'FedraSerifAPro'
  font-size 3.5em
  font-weight bold
  color #8E0038

  @media screen and (max-width: 39.9375em) {
    font-size 2.2em
  }
}

</style>